export default "__VITE_ASSET__Vv7zbjYg__"